export default __webpack_public_path__ + "static/media/pw_app_mobile.59325215.png";